import '~~/node_modules/spinkit/css/spinners/3-wave.css';
import '~/assets/sass/plugins/spinkit.sass';
import '~~/node_modules/please-wait/build/please-wait.css';
import { pleaseWait } from 'please-wait';
import loadingLogo from '~/assets/images/img_logo_niubiz_on_primary.svg';

window.loading_screen = pleaseWait({
    logo: loadingLogo,
    backgroundColor: '#47A8EE',
    loadingHtml: '\n      <div class="sk-wave">\n          <div class="sk-rect sk-rect1"></div>\n          <div class="sk-rect sk-rect2"></div>\n          <div class="sk-rect sk-rect3"></div>\n          <div class="sk-rect sk-rect4"></div>\n          <div class="sk-rect sk-rect5"></div>\n      </div>\n    '
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/loading-screen.js
// module id = ./src/plugins/loading-screen.js
// module chunks = 33